import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var ParticipationLoanHelper = function ParticipationLoanHelper() {
  _classCallCheck(this, ParticipationLoanHelper);

  _defineProperty(this, "PARTICIPATIONLOANTYPES", ["Bank of America", "Fannie Mae", "Great Southern Bank", "Pulaski", "US Bank"]);
};

export default new ParticipationLoanHelper();